export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_13.013b5094.jpg";